import React from "react";
import SubTruxLogo from "./SubTruxLogo.svg";

const SubTruxBrand = () => {
    return (
        <p className="subtrux-brand">
            <a href="https://www.subtrux.com" target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none'}}>
            <span className="powered-by">Powered by</span> <img className="subtrux-logo" alt="SubTrux" src={SubTruxLogo} width={30} height={30} />Sub<strong>Trux</strong></a>
        </p>
    )
}

export default SubTruxBrand;
